import React, { useState, useContext, useEffect } from "react";
import "./style.scss";
import Icon from "react-icons-kit";
import { edit2 } from "react-icons-kit/feather";
// import QuickItems from '../../../components/MyBiye/QuickItems/Index'
import { UserContext } from "../../../utils/context/userContext";
// import InputRange from 'react-input-range'
// import Slider from 'rc-slider';
// import 'rc-slider/assets/index.css';
import { Range } from "react-range";
import { HeightCalculatetoNumber } from "../../../utils/helpers";
// import Loading from '../../../components/Loading/Index'
import { useNavigate } from "react-router-dom";

const Index = () => {
  let navigate = useNavigate();
  const { user } = useContext(UserContext);
  // const { Range } = Slider;
  const data = user?.partnerPreference;
  const [ages, setAges] = useState({
    min: null,
    max: null,
  });
  const [heights, setheights] = useState({
    min: null,
    max: null,
  });

  const formatHeight = (value) => {
    const [feet, inches] = value.toString().split(".");
    return `${feet}'${inches || 0}"`;
  };

  useEffect(() => {
    if (!data) return;
console.log(data);

    const startAge = Number(data?.ageRange?.startFrom ?? 18);
    const endAge = Number(data?.ageRange?.endTo ?? 30);

    setAges({
      min: Math.min(startAge, endAge),
      max: Math.max(startAge, endAge),
    });

    const startHeight =
  data?.heightRange?.startFrom != null
    ? HeightCalculatetoNumber(data.heightRange.startFrom)
    : 5;

const endHeight =
  data?.heightRange?.endTo != null
    ? HeightCalculatetoNumber(data.heightRange.endTo)
    : 6;
    setheights({
      min: Math.min(startHeight, endHeight),
      max: Math.max(startHeight, endHeight),
    });
  }, [data]);

  // useEffect(() => {
  //     setAges({
  //         min: data?.ageRange.startFrom,
  //         max: data?.ageRange.endTo
  //     })
  //     setheights({
  //         min: HeightCalculatetoNumber(data?.heightRange.startFrom),
  //         max: HeightCalculatetoNumber(data?.heightRange.endTo)
  //     })
  // }, [data])

  const changeUrl = () => {
    navigate("/my-metrimony/profile?dv=parpre");
  };
  // if (!user) return <Loading />

  return (
    <div className="preference-container">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="d-lg-flex">
              {/* <QuickItems /> */}

              <div className="flex-fill main-section px-lg-4 pt-4 pt-lg-0 pb-4">
                <div className="title-section d-flex justify-content-between mb-4">
                  <div className="mb-0">
                    <h4>Overviews</h4>
                  </div>
                  <div className="ml-auto ">
                    <button
                      className="btn rounded-circle shadow"
                      onClick={changeUrl}
                    >
                      <Icon icon={edit2} size={20} />
                    </button>
                  </div>
                </div>
                {data === undefined ? (
                  <div className="">
                    {/* {user  === undefined &&  <Loading />} */}
                  </div>
                ) : (
                  <div className="row">
                    <div className="card shadow mb-4 border-0">
                      <div className="card-body p-4">
                        <div className="row">
                          <div className=" col-12 col-md-6 ">
                            <table>
                              <thead>
                                <tr>
                                  <th>Age range</th>
                                  <td className="pl-5">:</td>

                                  <td>
                                    {ages.min !== null && ages.max !== null && (
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "15px",
                                        }}
                                      >
                                        <div style={{ textAlign: "center" }}>
                                          {ages.min} - {ages.max} Years
                                        </div>
                                        <div style={{ width: "250px" }}>
                                          <Range
                                            step={1}
                                            min={18}
                                            max={80}
                                            values={[ages.min, ages.max]}
                                            onChange={(values) =>
                                              setAges({
                                                min: values[0],
                                                max: values[1],
                                              })
                                            }
                                            renderTrack={({
                                              props,
                                              children,
                                            }) => (
                                              <div
                                                {...props}
                                                style={{
                                                  height: "6px",
                                                  background: "#ddd",
                                                  borderRadius: "5px",
                                                  display: "flex",
                                                  marginBottom: "-2px",
                                                  alignItems: "center",
                                                  width: "100%",
                                                }}
                                              >
                                                {children}
                                              </div>
                                            )}
                                            renderThumb={({ props }) => (
                                              <div
                                                {...props}
                                                style={{
                                                  width: "18px",
                                                  height: "18px",
                                                  background: "#22403A",
                                                  borderRadius: "50%",
                                                  border: "2px solid #fff",
                                                  boxShadow:
                                                    "0 2px 6px rgba(0,0,0,0.3)",
                                                  marginTop: "5px", // thumb-কে track-এর center-এ আনে
                                                }}
                                              />
                                            )}
                                          />
                                        </div>
                                      </div>
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <th>Height range</th>
                                  <td className="pl-5">:</td>
                                  <td>
                                    {heights.min !== null &&
                                      heights.max !== null && (
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "15px",
                                          }}
                                        >
                                          <div style={{ textAlign: "center" }}>
                                            {formatHeight(heights.min)} -{" "}
                                            {formatHeight(heights.max)}
                                          </div>
                                          <div style={{ width: "275px" }}>
                                            <Range
                                              step={0.1}
                                              min={4}
                                              max={9}
                                              values={[
                                                heights.min,
                                                heights.max,
                                              ]}
                                              onChange={(values) =>
                                                setheights({
                                                  min: values[0],
                                                  max: values[1],
                                                })
                                              }
                                              renderTrack={({
                                                props,
                                                children,
                                              }) => (
                                                <div
                                                  {...props}
                                                  style={{
                                                    height: "6px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    width: "100%",
                                                    background: "#ddd",
                                                    borderRadius: "5px",
                                                  }}
                                                >
                                                  {children}
                                                </div>
                                              )}
                                              renderThumb={({ props }) => (
                                                <div
                                                  {...props}
                                                  style={{
                                                    width: "18px",
                                                    height: "18px",
                                                    background: "#22403A",
                                                    borderRadius: "50%",
                                                    border: "2px solid #fff",
                                                    boxShadow:
                                                      "0 2px 6px rgba(0,0,0,0.3)",
                                                    marginTop: "5px", // thumb-কে track-এর center-এ আনে
                                                  }}
                                                />
                                              )}
                                            />
                                          </div>
                                        </div>
                                      )}
                                  </td>
                                </tr>
                              </thead>
                            </table>
                          </div>
                          <div className="col-12 col-md-6 ">
                            <table>
                              <thead>
                                <tr>
                                  <th>Material status</th>
                                  <td className="pl-5">:</td>
                                  <td>
                                    {data?.materialStatus?.length
                                      ? data.materialStatus
                                      : "N/A"}
                                  </td>
                                </tr>
                                <tr>
                                  <th>Religion / Community</th>
                                  <td className="pl-5">:</td>
                                  <td>
                                    {data?.religion?.length
                                      ? data.religion[0]
                                      : "N/A"}
                                  </td>
                                </tr>
                                <tr>
                                  <th>Mother tongue</th>
                                  <td className="pl-5">:</td>
                                  <td>
                                    {data?.motherTongue
                                      ? data.motherTongue
                                      : "N/A"}
                                  </td>
                                </tr>
                              </thead>
                            </table>
                          </div>
                        </div>
                        {/* <p className="text-justify"></p> */}
                      </div>
                    </div>

                    {/* Location & grew up in details */}
                    <div className="card shadow mb-4 border-0">
                      <div className="card-body p-4">
                        <h5 className="mb-4" style={{ color: "#22403A" }}>
                          Location & grew up in details
                        </h5>
                        <div className="row">
                          <div className=" col-12 col-md-6 ">
                            <table>
                              <thead>
                                <tr>
                                  {/* Living country */}
                                  <th>Country</th>
                                  <td className="pl-5">:</td>

                                  <td>
                                    {data?.location?.country.length
                                      ? data.location.country
                                      : "N/A"}
                                  </td>
                                </tr>
                                <tr>
                                  {/* Living state */}
                                  <th>Living state / Divition</th>
                                  <td className="pl-5">:</td>
                                  <td>
                                    {data?.location?.stateDivision.length
                                      ? data.location.stateDivision
                                      : "N/A"}
                                  </td>
                                </tr>

                                <tr>
                                  {/* Residency status */}
                                  <th>City</th>
                                  <td className="pl-5">:</td>
                                  <td>
                                    {data?.location?.city.length
                                      ? data.location.city
                                      : "N/A"}
                                  </td>
                                </tr>
                              </thead>
                            </table>
                          </div>
                        </div>
                        {/* <p className="text-justify"></p> */}
                      </div>
                    </div>

                    {/* Education & profession details */}
                    <div className="card shadow mb-4 border-0">
                      <div className="card-body p-4">
                        <h5 className="mb-4" style={{ color: "#22403A" }}>
                          Education & profession details
                        </h5>
                        <div className="row">
                          <div className=" col-12 col-md-6 ">
                            <table>
                              <thead>
                                <tr>
                                  {/* Qualification */}
                                  <th>Qualification</th>
                                  <td className="pl-5">:</td>

                                  <td>
                                    {data?.educationAndProfession?.qualification
                                      .length
                                      ? data.educationAndProfession
                                          .qualification
                                      : "N/A"}
                                  </td>
                                </tr>
                                <tr>
                                  {/* Working with */}
                                  <th>Working with</th>
                                  <td className="pl-5">:</td>
                                  <td>
                                    {data?.educationAndProfession?.workingWith
                                      .length
                                      ? data.educationAndProfession.workingWith
                                      : "N/A"}
                                  </td>
                                </tr>

                                <tr>
                                  {/* Profession area */}
                                  <th>Profession area</th>
                                  <td className="pl-5">:</td>
                                  <td>
                                    {data?.educationAndProfession
                                      ?.professionArea.length
                                      ? data.educationAndProfession
                                          .professionArea
                                      : "N/A"}
                                  </td>
                                </tr>

                                <tr>
                                  {/* Annual income */}
                                  <th>Annual income </th>
                                  <td className="pl-5">:</td>
                                  <td>
                                    {data?.annualIncome?.startFrom
                                      ? `${data.annualIncome.startFrom}-${data.annualIncome.endTo}`
                                      : "Doesn't Matter"}
                                  </td>
                                </tr>
                              </thead>
                            </table>
                          </div>
                        </div>
                        {/* <p className="text-justify"></p> */}
                      </div>
                    </div>
                    {/* Age Section */}
                    {/* <div className="col-8 mb-4">
                                        <div className="form-group">
                                            <p className="mb-4">Age range</p>
                                            {
                                                ages.min ?
                                                    <Range
                                                        className="form-control shadow-none"
                                                        max={50}
                                                        min={18}
                                                        value={ages}
                                                        disabled
                                                    />
                                                    :
                                                    "----"
                                            }

                                        </div>
                                    </div> */}
                    {/* Height Section */}
                    {/* <div className="col-8 mb-4">
                                        <div className="form-group">
                                            <p className="mb-4">Height range</p>
                                            {
                                                heights.min && heights.min !== 'NaN.NaN' ?
                                                    // <Range
                                                    //     className="form-control shadow-none"
                                                    //     max={7}
                                                    //     minValue={4}
                                                    //     value={heights}
                                                    //     disabled
                                                    // />
                                                    <Range
                                                        className="form-control shadow-none"
                                                        min={4}
                                                        max={7}
                                                        value={heights}
                                                        disabled={true}
                                                        // onChange={setHeights}  // Optional if you want it controlled and editable
                                                    />
                                                    :
                                                    "----"
                                            }

                                        </div>
                                    </div> */}
                    {/* Material status */}
                    {/* <div className="col-12 mb-4">
                                        <div className="form-group mb-4">
                                            <p>Material status</p>
                                            <p className="custom-input">
                                                {data?.materialStatus?.length ? data.materialStatus : "----"}
                                            </p>
                                        </div>
                                    </div> */}

                    {/* Religion / Community */}
                    {/* <div className="col-12">
                                        <div className="form-group mb-4">
                                            <p>Religion / Community</p>
                                            <p className="custom-input">
                                                {data?.religion?.length ? data.religion[0] : "----"}
                                            </p>
                                        </div>
                                    </div> */}

                    {/* Mother tongue */}
                    {/* <div className="col-12">
                                        <div className="form-group mb-4">
                                            <p>Mother tongue</p>
                                            <p className="custom-input">
                                                {data?.motherTongue ? data.motherTongue : "----"}
                                            </p>
                                        </div>
                                    </div> */}

                    {/* Location & grew up in details */}
                    {/* <div className="col-12 py-3">
                                        <h5 className="mb-0">Location & grew up in details</h5>
                                    </div> */}

                    {/* Living country */}
                    {/* <div className="col-12">
                                        <div className="form-group mb-4">
                                            <p>Country</p>
                                            <p className="custom-input">
                                                {data?.location?.country.length ? data.location.country : "----"}
                                            </p>

                                        </div>
                                    </div> */}

                    {/* Living state */}
                    {/* <div className="col-12">
                                        <div className="form-group mb-4">
                                            <p>Living state / Divition</p>
                                            <p className="custom-input">
                                                {data?.location?.stateDivision.length ? data.location.stateDivision : "----"}
                                            </p>
                                        </div>
                                    </div> */}

                    {/* Residency status */}
                    {/* <div className="col-12">
                                        <div className="form-group mb-4">
                                            <p>City</p>
                                            <p className="custom-input">
                                                {data?.location?.city.length ? data.location.city : "----"}
                                            </p>
                                        </div>
                                    </div> */}

                    {/* Education & profession details */}
                    {/* <div className="col-12 py-3">
                                        <h5 className="mb-0">Education & profession details</h5>
                                    </div> */}

                    {/* Qualification */}
                    {/* <div className="col-12">
                                        <div className="form-group mb-4">
                                            <p>Qualification</p>
                                            <p className="custom-input">
                                                {data?.educationAndProfession?.qualification.length ? data.educationAndProfession.qualification : "----"}
                                            </p>
                                        </div>
                                    </div> */}

                    {/* Working with */}
                    {/* <div className="col-12">
                                        <div className="form-group mb-4">
                                            <p>Working with</p>
                                            <p className="custom-input">
                                                {data?.educationAndProfession?.workingWith.length ? data.educationAndProfession.workingWith : "----"}
                                            </p>
                                        </div>
                                    </div> */}

                    {/* Profession area */}
                    {/* <div className="col-12">
                                        <div className="form-group mb-4">
                                            <p>Profession area</p>
                                            <p className="custom-input">
                                                {data?.educationAndProfession?.professionArea.length ? data.educationAndProfession.professionArea : "----"}
                                            </p>
                                        </div>
                                    </div> */}

                    {/* Annual income */}
                    {/* <div className="col-12">
                                        <div className="form-group mb-4">
                                            <p>Annual income</p>
                                            <p className="custom-input">
                                                {data?.annualIncome?.startFrom ? `${data.annualIncome.startFrom}-${data.annualIncome.endTo}` : "Doesn't Matter"}
                                            </p>
                                        </div>
                                    </div> */}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
